<template>
  <el-form-item :label="$t('settingOrderMoney.amountType')" prop="type">
    <BjSelectLov v-model="id" :option-list="ORDER_MONEY_TYPE_LIST" :loading="loading" />
  </el-form-item>
</template>
<script>
import { orderApi } from '@/api';
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      id: null,
      ORDER_MONEY_TYPE_LIST: [],
    };
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
      this.$emit('change', v);
    },
  },
  created() {
    this.loading = true;
    orderApi.getPriceType().then(res => {
      this.ORDER_MONEY_TYPE_LIST = res;
      this.loading = false;
    });
  },
  methods: {},
};
</script>
